// Shared filter chips + status pill for the Properties and Entities tabs (previously copy-pasted).
import { Box } from '@material-ui/core';

export type TrackRecordStatus = 'verified' | 'needsInput';
export type TrackRecordFilter = 'all' | 'needsInput' | 'verified';

// The verified / needs-input status pill used in every track-record table row.
export const StatusPill = ({ classes, status }: { classes: Record<string, string>; status: TrackRecordStatus }) => (
  <span className={`${classes.statusPill} ${status === 'verified' ? classes.statusVerified : classes.statusNeedsInput}`}>
    <span className={`${classes.statusDot} ${status === 'verified' ? classes.statusVerifiedDot : classes.statusNeedsInputDot}`} />
    {status === 'verified' ? 'Verified' : 'Not Verified'}
  </span>
);

// The All / Not Verified / Verified filter chip row shared by both tabs.
export const TrackRecordFilterChips = ({
  classes,
  selected,
  onSelect,
  total,
  needsInputCount,
  verifiedCount,
}: {
  classes: Record<string, string>;
  selected: TrackRecordFilter;
  onSelect: (filter: TrackRecordFilter) => void;
  total: number;
  needsInputCount: number;
  verifiedCount: number;
}) => (
  <Box className={classes.filterRow}>
    {([
      { key: 'all', label: `All ${total}` },
      { key: 'needsInput', label: `Not Verified ${needsInputCount}` },
      { key: 'verified', label: `Verified ${verifiedCount}` },
    ] as const).map((filter) => (
      <button
        key={filter.key}
        type="button"
        className={`${classes.filterChip} ${selected === filter.key ? classes.filterChipActive : ''}`}
        onClick={() => onSelect(filter.key)}
      >
        {filter.label}
      </button>
    ))}
  </Box>
);
